// Minutes a delivery can run late and still count as on-time.
export const ON_TIME_BUFFER_MINUTES = 3;

export const CAFE_ZUPAS_ENTERPRISE_ID = 546;

// Enterprises that get the on-time grace buffer.
export const ON_TIME_BUFFER_ENTERPRISE_IDS = [CAFE_ZUPAS_ENTERPRISE_ID];
